import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { CompanyApi } from './apis/company-api';
import { CompanyApiImpl } from './apis/impls/company-api';
import { CompanyEurekaApi } from './apis/company-eureka-api';
import { CompanyEurekaApiImpl } from './apis/impls/company-eureka-api';
import { CompanyRepository } from './services/company-repository';
import { CompanyRepositoryImpl } from './repositories/impls/company-repository';
import { CompanyService } from './services/company-service';
import { CompanyServiceImpl } from './services/impls/company-service';

export * from './types'

export const companyContainer = new ContainerModule(bind => {
    bind(CompanyApi).to(CompanyApiImpl);
    bind(CompanyEurekaApi).to(CompanyEurekaApiImpl);
    bind(CompanyRepository).to(CompanyRepositoryImpl);
    bind(CompanyService).to(CompanyServiceImpl);
});
